<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- general tab -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="InfoIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Tiket</span>
      </template>
      <!-- v-if="options.proyek"
      :data-proyek="options.proyek" -->
      <tiket @clicked="simpanTiket" />
    </b-tab>
    <!--/ general tab -->

    <b-tab v-if="this.$route.params.id">
      <template #title>
        <feather-icon icon="CalendarIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Form</span>
      </template>

      <form-tiket @clicked="simpanForm" :key="loadForm" />
    </b-tab>

    <b-tab v-if="showTabAssign">
      <template #title>
        <feather-icon icon="UserIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Assign</span>
      </template>
      <koordinator />
    </b-tab>

    <b-tab
      v-if="
        this.rows &&
          $can('assign', 'tiket') &&
          this.rows.status_tiket_id !== 'e2281ff8-2558-11ee-acb1-3497f616f0'
      "
    >
      <template #title>
        <feather-icon icon="UserIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Biodata</span>
      </template>

      <biodata />
    </b-tab>

    <!-- <b-tab
      v-if="this.$route.params.id"
    >
      <template #title>
        <feather-icon
          icon="BriefcaseIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Dokumen</span>
      </template>

      <view-dokumen-lainnya
        :user-data="rowData"
        :dataJenisDokumen="dataMasterJenisDokumenLainnya"
        :canManage="true"
        :jenisPermohonanId="jenisPermohonanId"
        :permohonanId="permohonanId"
        @emitReceiver="reloadData"
      />
    </b-tab>

    <b-tab
      v-if="this.$route.params.id"
    >
      <template #title>
        <feather-icon
          icon="BriefcaseIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Foto & Video</span>
      </template>

      <view-dokumen-foto
        :user-data="rowData"
        :dataJenisDokumen="dataMasterJenisDokumenFoto"
        :canManage="true"
        :jenisPermohonanId="jenisPermohonanId"
        :permohonanId="permohonanId"
        @emitReceiver="reloadData"
      />
    </b-tab> -->
    <!-- di hide dlu
        START
    -->
    <!-- <b-tab
        v-if="this.rows && $can('assign', 'tiket')"
      >
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Helpdesk</span>
        </template>

        <koordinator/>
      </b-tab>
      <b-tab
        v-if="this.$route.params.id"
      >
        <template #title>
          <feather-icon
            icon="MessageSquareIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Chat</span>
        </template>

        <card-advance-chat
          :keyId="this.$route.params.id"
          :keyTable="keyTable"
        />
      </b-tab> -->
    <!-- END START-->
    <!-- <b-tab
      v-if="this.$route.params.id && $can('tabuser', 'kegiatan')"
      :active="activeUser"
    >
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">User</span>
      </template>
      <user/>
    </b-tab>
    <b-tab
      v-if="this.$route.params.id && $can('tablink', 'kegiatan')"
    >
      <template #title>
        <feather-icon
          icon="Link2Icon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Link</span>
      </template>
      <form-link/>
    </b-tab> -->
    <b-toast />
  </b-tabs>
</template>

<script>
import { BTabs, BTab, BToast } from 'bootstrap-vue'
import router from '@/router'
import { insTiket, ubahTiket, getTiket } from '@/connection-api/tiket'
// import CardAdvanceChat from '@/views/layouts/CardAdvanceChat.vue'
import FormTiket from './detail-form/FormTiket.vue'
import Tiket from './detail-form/Tiket.vue'
import Koordinator from './detail-form/Koordinator.vue'
import Biodata from './detail-form/Biodata.vue'
// import ViewDokumenLainnya from './form/ViewDokumenLainnya.vue'
// import ViewDokumenFoto from './form/ViewDokumenFoto.vue'
import User from './form/User.vue'
import FormLink from './form/Link.vue'

export default {
  components: {
    BTabs,
    BTab,
    Tiket,
    FormTiket,
    Koordinator,
    Biodata,
    // ViewDokumenLainnya,
    // ViewDokumenFoto,
    // User,
    // FormLink,
    BToast,
    // CardAdvanceChat,
  },
  data() {
    return {
      options: {},
      keyTable: 'tiket',
      loadForm: 1,
      rows: {},
      showTabAssign: false,
    }
  },
  async mounted() {
    // console.log
    // console.log('aaaaaa')
    if (this.$route.params.id) {
      const params = {}
      // if (this.$can('proses', 'tiket')) {
      //   params = { proses: false }
      // }
      const response = await getTiket(this.$route.params.id, params)
      this.rows = response.data.data
    }

    if (this.rows.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe6') {
      this.showTabAssign = true
    } else {
      this.showTabAssign = false
    }
  },
  methods: {
    async simpanTiket(value) {
      try {
        // value.proyek_id = value.select_proyek.selected
        const response = await insTiket(value)
        // console.log(response)
        if (value.tiket_id) {
          this.makeToast('success', 'Ubah Tiket Berhasil!')
        } else {
          this.makeToast('success', 'Tambah Tiket Berhasil!')
          setTimeout(
            () =>
              // eslint-disable-next-line implicit-arrow-linebreak
              this.$router.push({
                name: 'pages-tiket-ubah',
                params: { id: response.data.tiket_id },
              }),
            500,
          )
        }
      } catch (error) {
        this.makeToast('danger', error.response.data.data)
        this.show = false
      }
      this.loadForm += 1
    },
    async simpanForm(value) {
      // console
      value.form = 'form'
      if (value.id) {
        const response = await ubahTiket(value)
        if (response.data.status.code === '00') {
          this.makeToast('success', 'Lengkapi Data Berhasil!')
        } else {
          this.makeToast('danger', response.data.data)
          this.show = false
        }
        // this.makeToast('danger', error.response.data)
        // this.show = false
      }
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Tiket',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
  },
  // beforeCreate() {
  //   // this.$http.get('/kegiatan/data').then(res => { this.options = res.data })
  // },
}
</script>
